const stories = [
  {
    id: "yuanjia-tension",
    tag: "恋爱拉扯",
    title: "为什么「冤家拉扯」越吵越好嗑？",
    excerpt:
      "针锋相对的两个人，为什么总能在互怼里悄悄心动？拆解拉扯剧情的糖分密码，看脸红与傲娇如何成就最好嗑的桥段。",
    read: "6分钟",
    date: "3天前",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20playful%20characters%20arguing%20and%20laughing%20under%20warm%20coral%20light%2C%20playful%20banter%20romance%2C%20warm%20peach%20and%20rose%20palette%2C%20clean%20vibrant%20style&width=800&height=500&seq=story-yuanjia-01&orientation=landscape",
  },
  {
    id: "honglian-moment",
    tag: "脸红情节",
    title: "脸红情节的正确打开方式",
    excerpt:
      "一个恰到好处的脸红瞬间，胜过千言万语。从耳尖泛红到视线躲闪，盘点那些让人跟着心跳加速的高能画面。",
    read: "5分钟",
    date: "5天前",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20blushing%20girl%20covering%20her%20cheeks%20with%20soft%20pink%20glow%2C%20warm%20romantic%20atmosphere%2C%20pastel%20cream%20and%20rose%20palette%2C%20clean%20vibrant%20style&width=800&height=500&seq=story-honglian-01&orientation=landscape",
  },
  {
    id: "ganqing-rhythm",
    tag: "情感发展",
    title: "从暗恋到告白：情感发展的黄金节奏",
    excerpt:
      "感情线慢慢升温的作品为什么更动人？带你理解铺垫、试探与确认之间的关系，读懂情感发展里那些欲言又止的心动。",
    read: "7分钟",
    date: "1周前",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20couple%20slowly%20reaching%20hands%20toward%20each%20other%20with%20warm%20golden%20sunset%2C%20tender%20romantic%20moment%2C%20warm%20peach%20palette%2C%20clean%20vibrant%20style&width=800&height=500&seq=story-ganqing-01&orientation=landscape",
  },
  {
    id: "chuntian-secret",
    tag: "纯爱甜宠",
    title: "纯爱甜宠不腻的秘诀",
    excerpt:
      "高甜不等于腻味，好的甜宠作品总能在糖里藏进真心。聊聊双向奔赴的甜宠如何兼顾心动感与剧情深度。",
    read: "5分钟",
    date: "2周前",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sweet%20couple%20sharing%20a%20cherry%20blossom%20umbrella%20with%20warm%20pink%20petals%20falling%2C%20sweet%20romantic%20atmosphere%2C%20warm%20peach%20palette%2C%20clean%20vibrant%20style&width=800&height=500&seq=story-chuntian-01&orientation=landscape",
  },
];

export default function Stories() {
  return (
    <section id="stories" className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-600">
            <i className="ri-book-open-fill"></i>
            剧情解读
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">恋爱剧情这样嗑才对</h2>
          <p className="mt-2 text-[15px] text-foreground-600">
            编辑部不定期出品的恋爱漫画剧情解析，教你读懂拉扯、脸红与情感升温。
          </p>
        </div>
        <span className="flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-4 py-2 text-sm text-secondary-800">
          <i className="ri-time-line"></i>
          每周更新
        </span>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stories.map((s) => (
          <article
            key={s.id}
            className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-secondary-200"
          >
            <div className="relative aspect-[16/10] w-full overflow-hidden">
              <img
                src={s.cover}
                alt={`${s.title} 恋爱剧情解读`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                {s.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-[15px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-secondary-700">
                {s.title}
              </h3>
              <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{s.excerpt}</p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-account-circle-line"></i>
                  桃桃编辑部
                </span>
                <span className="flex items-center gap-2">
                  <span>{s.read}</span>
                  <span>{s.date}</span>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}